import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BnDropdownService {
  private closeAllDropdowns$ = new Subject<string>();

  public closeAllDropdowns(id: string): void {
    this.closeAllDropdowns$.next(id);
  }

  public getCloseAllDropdowns$(): Observable<string> {
    return this.closeAllDropdowns$.asObservable();
  }
}
